<div class="relative h-[100%]  pt-[40px] pb-[40px]" [@pageLoad]="pageLoadState">

  <div
  class="gap-[40px] flex flex-col justify-around items-center px-[64px]  w-full h-[100%] font-archivo ">
  <div class="flex flex-col w-full h-[100%] justify-between">
  <div
    class="gap-[80px] flex flex-col w-full justify-start items-center pb-[160px] pt-[160px] ">
    <div class="gap-[40px] flex flex-col w-full justify-start items-center">
      <span
        class="w-full text-[#111215] text-center font-archivo font-bold tracking-[0.1rem] text-[24px] leading-[29px]">
        Schedule Your Meal and Transportation
      </span>
      <div
        class="gap-[20px] flex flex-row w-full justify-center items-stretch flex-wrap px-[48px]">
        <ng-container *ngFor="let option of dateOptions; let i = index">
        <button
          *ngIf="!option.submitted"
          type="button"
          (click)="handleCardClick(i)"
          (keydown)="handleCardKeyDown($event, i)"
          [attr.data-card-state]="option.state"
          [attr.aria-label]="'Select date ' + option.dateLabel"
          class="date-card relative flex flex-col w-[260px] rounded-[16px] cursor-pointer border-[#A1A4AA] border-[2px] overflow-hidden focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D] text-left"
          [ngClass]="{
            '': option.state === 'today' || option.state === 'selected',
            'hover:border-[#A1A4AA]/50': option.state === 'default'
          }">
          <!-- Header -->
          <div
            class="flex flex-row w-full gap-[8px] justify-center items-center px-[12px] pt-[12px] pb-[12px] border-b-[2px] border-b-[#A1A4AA] "
            [ngClass]="{
              'bg-[#F0A169] ': option.state === 'today',
              'bg-[#4caf50] ': option.state === 'selected',
              'bg-white ': option.state === 'default'
            }">
            <span
              class="text-center font-archivo font-bold uppercase  leading-[32px] text-[18px] font-normal text-center"
              [ngClass]="{
                'text-[#5d6470]': option.state === 'default',
                'text-white': option.state !== 'default'
              }">
              {{ option.dayLabel }}
            </span>
            <div
            *ngIf="option.state === 'selected'"
            class="gap-[8px] flex flex-row w-[24px] h-[24px] shrink-0 rounded-[100px] justify-end items-start pl-[4px] pr-[2px] pt-[2px] pb-[4px] bg-[#088242]">
            <img
                src="assets/icons/check.svg"
                alt="Selected"
                loading="lazy"
                decoding="async"
                class="w-[20px] h-[20px] shrink-0 justify-start items-start " />
        </div>
          </div>

          <!-- Body -->
          <div
            class="relative flex flex-col w-full justify-start items-center px-[14px] pt-[16px] pb-[16px] grow"
            [ngClass]="{
              'bg-[#FFFFFF]  border-t-[#f26f24]': option.state === 'today',
              'bg-[#F2F5F7] border-t-[#5c8c60]': option.state === 'selected',
              'bg-[#FFFFFF] border-t-[#A1A4AA]': option.state === 'default'
            }">
            <span
              class="w-full text-[#111215] text-center font-archivo font-bold text-[22px] leading-[26px]">
              {{ option.dateLabel }}
            </span>
            <div
              *ngIf="option.hotMenuText || option.coldMenuText"
              class="flex flex-col w-full gap-[6px] pt-[8px] items-start text-left">
              <span
                *ngIf="option.hotMenuText"
                class="w-full text-[#444955] font-archivo font-normal text-[12px] leading-[16px]">
                Hot: {{ option.hotMenuText }}
              </span>
              <span
                *ngIf="option.coldMenuText"
                class="w-full text-[#444955] font-archivo font-normal text-[12px] leading-[16px]">
                Cold: {{ option.coldMenuText }}
              </span>
            </div>
            <div
              *ngIf="option.badgeCount"
              class="absolute bottom-0 right-0 flex flex-row items-center gap-[4px] rounded-tl-[6px] rounded-br-[12px] bg-[#f26f24] px-[8px] py-[6px] shadow-sm">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="shrink-0">
                <circle cx="12" cy="12" r="10" stroke="white" stroke-width="2.5" />
                <path d="M12 6V12L16 14" stroke="white" stroke-width="2.5" stroke-linecap="round" />
              </svg>
              <span
                class="text-white font-open-sans font-bold text-[18px] leading-none">
                {{ option.badgeCount }}
              </span>
            </div>
          </div>

          <!-- Location footer: shown only when a check-in location is recorded for this date -->
          <div
            *ngIf="option.locationName && option.state === 'selected'"
            class="flex flex-row w-full items-center justify-center gap-[6px] px-[12px] py-[8px] bg-[#e8f5e9] border-t border-t-[#c8e6c9]">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="shrink-0 text-[#2e7d32]">
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                fill="#2e7d32" />
              <circle cx="12" cy="9" r="2.5" fill="white" />
            </svg>
            <span class="text-[#2e7d32] font-archivo font-semibold text-[12px] leading-[16px] truncate">
              {{ option.locationName }}
            </span>
          </div>
        </button>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Navigation Buttons -->
  <div class="gap-[8px] flex flex-row w-[100%]  justify-between items-center ">
    <NiButton
      variant="outlined"
      color="secondary"
      size="[20px]"
      label="Back"
      leadingIcon="arrowNarrowLeft"
      [px]="'[24px]'"
      [py]="'[16px]'"
      [rounded]="'[999px]'"
      border="1"
      borderColor="[#5BA5F5]"
      bg="transparent"
      fontSize="[20px]"
      (onClick)="onBackClick()"
      [styleClass]="
        'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
        `'archivo'] text-[18px] leading-[23px] line-height-[24px]'`">
    </NiButton>
  </div>
  </div>
</div>
</div>